export enum RiskType {
  low = 'Low',
  medium = 'Medium',
  increased = 'Increased',
  high = 'High'
}
